import axiosInstance from '../../../config/axiosInstance';
const  AssetHistoryService = {
    async GetAllAssetHistory(redirectCallback,ID) {
        try {            
            const response = await axiosInstance.get(`/Asset/GetAllAssetHistory?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteAssetHistory(redirectCallback,ID) {
        try {            
            const response = await axiosInstance.get(`/Asset/DeleteAssetHistory?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default AssetHistoryService;